import { callConfigFunction } from './callConfigFunction';
/**
 * Calls an event function defined in the widget config.
 *
 * @param {WidgetProps<any, any>} props - The widget props containing config and context.
 * @param {string} eventName - The name of the event function to call (e.g., 'onClick', 'onChange').
 * @param {string} argumentNames - A comma-separated string of parameter names used in the function body.
 * @param {...any} argumentValues - Values to pass as arguments to the function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function callEventFunction(props, eventName, argumentNames, ...argumentValues) {
    var _a;
    callConfigFunction((_a = props.config.event) === null || _a === void 0 ? void 0 : _a[eventName], 'event ' + eventName, argumentNames, ...argumentValues);
}
